import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "../../lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-primary/30 bg-primary text-primary-foreground",
        secondary:
          "border-border bg-muted text-muted-foreground",
        success:
          "border-success/30 bg-success text-success-foreground",
        danger:
          "border-danger/30 bg-danger text-danger-foreground",
        warning:
          "border-warning/30 bg-warning text-warning-foreground",
        purple:
          "border-purple/30 bg-purple text-purple-foreground",
        yellow:
          "border-yellow/30 bg-yellow text-yellow-foreground",
        outline: "text-foreground border-border",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
